import { DateBuilder } from '@imcc/utilities';
import { IAsset } from '@imcc/transport';

export function downloadId(userId: string, searchHit: IAsset): string {
  const unix = DateBuilder.fromCurrent.unixMs;
  const { assetType, id } = searchHit;

  return [unix, userId, assetType, id].join('.');
}
